// extracted by mini-css-extract-plugin
export default {"page_box":"ModalDevice_page_box__TEmXd","page_before":"ModalDevice_page_before__Qm8zB","red":"ModalDevice_red__yU0iA","page_after":"ModalDevice_page_after__50XSS"};